import React from 'react';
import styled from 'styled-components';
import {
  Card,
  CardBody,
  CardHeader,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
} from '@grnhse/seedling/lib/azalea/components/card';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card_table'. 'node_modules/@grnhse/seedling/lib/azalea/components/card_table.js' implicitly has an 'any' type.
import CardTable from '@grnhse/seedling/lib/azalea/components/card_table';
import { SecondaryBodyText } from '@grnhse/seedling/lib/azalea/typography';
import { withLocalePrefix } from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../shared/error_boundary'. 'app/webpack/javascripts/gdpr/components/shared/error_boundary.js' implicitly has an 'any' type.
import ErrorBoundary from '../shared/error_boundary';
import AddARule from '../shared/add_a_rule';
import Divider from '../shared/divider';
import EmptyState from '../shared/empty_state';
import Loading from '../shared/loading';
import { Content } from '../shared/content';
import TableHeader from '../shared/table_header';
import { DataCollectionRulesContext } from './context';
import Rule from './rule';
import type { DataCollectionRuleInterface } from './data_collection_rule';
import { getCardGutter } from '../shared/card';

const t = withLocalePrefix('gdpr.data_collection_rules.view');

type Props = {
  emailTemplatePath: string;
};

function getHeaders() {
  return [
    { key: 'status', label: t('table.header.status'), width: '1%' },
    { key: 'offices', label: t('table.header.offices'), width: '60%' },
    {
      key: 'recipients',
      label: t('table.header.recipients'),
      width: '35%',
    },
    { key: 'actions', label: t('table.header.actions'), width: '1%' },
  ];
}

/**
 * Hide the header if the first rule is being edited
 * @param rules
 * @param editingRuleId
 * @returns {boolean}
 */
function shouldHideHeader(
  rules: Array<DataCollectionRuleInterface>,
  editingRuleId?: number | null
): boolean {
  const idx = rules.findIndex(
    (rule: DataCollectionRuleInterface) => rule.id === editingRuleId
  );

  return idx === 0;
}

export default function View(props: Props) {
  const { editing, editingRuleId, rules, loaded, onAdd } = React.useContext(
    DataCollectionRulesContext
  );

  return (
    <Card useLegacyPadding data-provides="gdpr_data_collection_rules">
      <CardHeader
        label={t('header')}
        labelSize="large"
        rightComponent={
          editing ? null : (
            <AddARule onClick={onAdd} dataProvides="add_collection_rule" />
          )
        }
      />
      <CardBody verticalCardGutter="medium" cardGutter={getCardGutter(false)}>
        <Content>
          <SecondaryBodyText>
            {t('content.description')}
            <a href={props.emailTemplatePath}>{t('content.configure')}</a>
          </SecondaryBodyText>
        </Content>
        {!loaded ? (
          <Loading />
        ) : !rules.length ? (
          // @ts-expect-error - TS2769 - No overload matches this call.
          <EmptyState emphasize data-provides="no_collection_rules_message">
            {t('content.empty')}
          </EmptyState>
        ) : (
          <ErrorBoundary>
            <StyledDivider />
            <CardTable
              headerComponent={
                <TableHeader
                  headers={getHeaders()}
                  hide={shouldHideHeader(rules, editingRuleId)}
                />
              }
            >
              {rules.map((rule) => (
                <Rule
                  key={rule.id}
                  rule={rule}
                  editing={rule.id === editingRuleId}
                />
              ))}
            </CardTable>
          </ErrorBoundary>
        )}
      </CardBody>
    </Card>
  );
}

const StyledDivider = styled(Divider)`
  margin-top: 25px;
`;
